export * from './DescriptionPanel';



// WEBPACK FOOTER //
// ./src/modules/AppCore/Component/Panel/index.js